/**
 * Use Link Document Hook
 *
 * Wraps the linkDocumentToChecklistItem mutation using useApiMutation
 * for consistent error handling.
 */

import { api } from "convex/_generated/api";
import { useApiMutation } from "@/packages/features-shared";
import type { Id } from "@/packages/types";

export function useLinkDocument() {
  const mutation = useApiMutation(
    api.checklist_mutations.linkDocumentToChecklistItem,
    {
      name: "link-document-to-checklist-item",
      successMessage: "Document linked",
    },
  );

  return (args: {
    documentId: Id<"documents">;
    checklistItemId: Id<"checklistItems">;
  }) => mutation.mutateAsync(args);
}
